module.exports = __webpack_public_path__ + "img/weddings_01_V.85ee1f3d.webp";